/* template */
<template minapp="mpx" xlang="wxml"><es-card-wrap1 :custom-style="(customStyle)"><es-descriptions :title="(title)" :custom-style="({padding: '12px 12px 16px'})" v-if="(title)"><slot/></es-descriptions></es-card-wrap1></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0448d4b8"}'>
  .card
    background-color white
    border-radius 8px
    margin 0px 12px
    padding 12px
  .card-title
    font-size 16px
    font-weight bold
    color black
    align-items center
  .card-divider
    width auto
    height 1px
    background-color #ebebeb
    // opacity 0.08
    margin-top 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0448d4b8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex0448d4b8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex0448d4b8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0448d4b8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index0448d4b8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-card-wrap1':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/card/card-wrap1.mpx?isComponent&outputPath=components%2Fcard-wrap120040920%2Findex")),'es-descriptions':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/descriptions/index.mpx?isComponent&outputPath=components%2Findexf02c563e%2Findex")),'order-inline-info':getComponent(require("../order-inline-info.mpx?isComponent&outputPath=components%2Forder-inline-infoaaf95858%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
